import { useTranslation } from "react-i18next";
import { useAuth } from "../context/AuthContext";
import { Globe } from "lucide-react";
import { LANGUAGES } from "../i18n";

/** Compact in-app language cycler (FR → EN → ES). */
export const LangSwitcher = ({ dark = false }) => {
  const { t, i18n } = useTranslation();
  const { setLanguage } = useAuth();
  const idx = Math.max(0, LANGUAGES.findIndex((l) => l.code === i18n.language));
  const next = LANGUAGES[(idx + 1) % LANGUAGES.length];
  return (
    <button
      data-testid="lang-switcher"
      aria-label={t("common.language")}
      onClick={() => setLanguage(next.code)}
      className={`inline-flex h-10 items-center gap-2 rounded-full px-4 text-sm font-semibold transition-colors active:scale-95 ${
        dark ? "bg-white/10 text-white hover:bg-white/20" : "bg-muted text-foreground hover:bg-secondary"
      }`}
    >
      <Globe className="h-4 w-4" />
      {next.label}
    </button>
  );
};
